import Api from 'services';

// ACTION TYPES
export const explorerHasErrored = () => ({ type: '[EXPLORER] HAS_ERRORED' });
export const explorerIsLoading = () => ({ type: '[EXPLORER] IS_LOADING' });
export const explorerFetchSuccess = data => ({ type: '[EXPLORER] FETCH_SUCCESS', data });

// ACTION TYPES COUNT
export const explorerCountHasErrored = () => ({ type: '[EXPLORER] COUNT_HAS_ERRORED' });
export const explorerCountIsLoading = () => ({ type: '[EXPLORER] COUNT_IS_LOADING' });
export const explorerCountFetchSuccess = data => ({ type: '[EXPLORER] COUNT_FETCH_SUCCESS', data });

// ACTION CREATORS
export const explorer_action_search = form => async dispatch => {

  dispatch(explorerIsLoading());
  await Api.Explorer.getSearch(form)
    .then(data => {
        //console.log(data);
     return  dispatch(explorerFetchSuccess(data))
    })
    .catch(() => dispatch(explorerHasErrored()));
};

// ACTION CREATORS
export const explorer_action_search_count = form => async dispatch => {

    dispatch(explorerCountIsLoading());
    await Api.Explorer.getCount(form)
        .then(data => {
           // console.log(data);
            return  dispatch(explorerCountFetchSuccess(data))
        })
        .catch(() => dispatch(explorerCountHasErrored()));
};
